import { groupBySection, type PlanChangeRow } from './change-format'

export function ChangeList({ rows }: { rows: PlanChangeRow[] }) {
  return (
    <div className="space-y-4">
      {groupBySection(rows).map(group => (
        <section key={group.id} aria-label={`${group.title} changes`} className="space-y-2">
          <h3 className="text-sm font-semibold">{group.title}</h3>
          <ul className="space-y-2">
            {group.rows.map(row => (
              <li key={row.field} className="min-w-0 text-sm">
                <p className="font-medium">{row.label}</p>
                <p className="break-words text-muted-foreground">
                  <span>{row.from}</span><span aria-hidden="true"> → </span><span className="sr-only"> changes to </span><span className="text-foreground">{row.to}</span>
                </p>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
